import { render, staticRenderFns } from "./Fiveind.vue?vue&type=template&id=9fa9499e"
import script from "./Fiveind.vue?vue&type=script&lang=js"
export * from "./Fiveind.vue?vue&type=script&lang=js"
import style0 from "./Fiveind.vue?vue&type=style&index=0&id=9fa9499e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports